import type { DesignItem, PlanTemplate } from "./model";
import { assetUrl } from "../lib/asset";

const item = (
  instanceId: string,
  refId: string,
  type: DesignItem["type"],
  qty: number,
  zone: DesignItem["zone"],
  x: number,
  y: number,
): DesignItem => ({ instanceId, refId, type, qty, zone, x, y });

export const planTemplates: PlanTemplate[] = [
  {
    id: "plan-sun-calm",
    name: "Nắng Thảnh Thơi",
    styleId: "tropical-soft",
    supportedLights: ["morning", "partial"],
    description: "Một góc đọc gập gọn, cụm cây nhiều tầng và dải đi giữa ban công.",
    image: assetUrl("/media/plan-nang-thanh-thoi.webp"),
    packageId: "balanced",
    items: [
      item("rn-01", "plant-lady-palm", "plant", 1, "left", 12, 18),
      item("rn-02", "plant-boston-fern", "plant", 2, "left", 28, 28),
      item("rn-03", "plant-spider", "plant", 2, "left", 42, 66),
      item("rn-04", "plant-peperomia", "plant", 1, "center", 50, 22),
      item("rn-05", "plant-rosemary", "plant", 1, "center", 63, 18),
      item("rn-06", "pot-lime-rect", "pot", 1, "left", 24, 34),
      item("rn-07", "pot-selfwater-32", "pot", 2, "center", 56, 31),
      item("rn-08", "pot-terracotta-32", "pot", 1, "center", 68, 28),
      item("rn-09", "furn-fold-chair", "furniture", 1, "right", 80, 55),
      item("rn-10", "furn-round-table", "furniture", 1, "right", 72, 72),
      item("rn-11", "acc-trellis", "accessory", 1, "right", 86, 18),
      item("rn-12", "acc-wall-light", "accessory", 1, "right", 92, 28),
    ],
  },
  {
    id: "plan-edible",
    name: "Bếp Có Nắng",
    styleId: "edible-wood",
    supportedLights: ["morning", "partial", "harsh"],
    description: "Rau thơm theo cụm, một cây quả lùn và bộ bàn trà có thể gập.",
    image: assetUrl("/media/style-moc-an.webp"),
    packageId: "balanced",
    items: [
      item("ed-01", "plant-rosemary", "plant", 2, "left", 15, 22),
      item("ed-02", "plant-basil", "plant", 2, "left", 28, 24),
      item("ed-03", "plant-mint", "plant", 1, "left", 40, 28),
      item("ed-04", "plant-calamansi", "plant", 1, "center", 55, 18),
      item("ed-05", "pot-terracotta-32", "pot", 4, "left", 28, 48),
      item("ed-06", "pot-selfwater-32", "pot", 1, "center", 55, 42),
      item("ed-07", "furn-tea-set", "furniture", 1, "right", 77, 57),
      item("ed-08", "acc-watering-can", "accessory", 1, "center", 59, 72),
      item("ed-09", "acc-pot-feet", "accessory", 1, "left", 31, 72),
      item("ed-10", "acc-drip-kit", "accessory", 1, "left", 44, 74),
      item("ed-11", "acc-wall-light", "accessory", 1, "right", 91, 20),
    ],
  },
  {
    id: "plan-shade",
    name: "Râm Mà Dịu",
    styleId: "quiet-shade",
    supportedLights: ["shade", "morning"],
    description: "Tập trung texture lá, chậu khoáng thấp và một ghế ngồi êm.",
    image: assetUrl("/media/style-tinh-ram.webp"),
    packageId: "balanced",
    items: [
      item("sh-01", "plant-lady-palm", "plant", 1, "left", 12, 20),
      item("sh-02", "plant-boston-fern", "plant", 2, "left", 28, 34),
      item("sh-03", "plant-birdnest-fern", "plant", 1, "center", 48, 24),
      item("sh-04", "plant-spider", "plant", 2, "center", 58, 55),
      item("sh-05", "plant-peperomia", "plant", 2, "center", 66, 34),
      item("sh-06", "pot-charcoal-40", "pot", 3, "left", 28, 58),
      item("sh-07", "pot-tall-cream", "pot", 1, "left", 13, 58),
      item("sh-08", "furn-low-chair", "furniture", 1, "right", 80, 55),
      item("sh-09", "furn-round-table", "furniture", 1, "right", 71, 70),
      item("sh-10", "acc-pot-feet", "accessory", 1, "center", 52, 77),
      item("sh-11", "acc-wall-light", "accessory", 1, "right", 92, 22),
    ],
  },
];
